import { format } from 'date-fns';
import { Text } from 'platform-components/index';
import React from 'react';

interface OwnProps {
    evaluationDate: Date | null;
}

interface Props extends OwnProps {}

const AssignmentEvaluationDateHint = ({ evaluationDate }: Props) => {
    if (!evaluationDate) {
        return null;
    }

    const deadlineDateStr = format(evaluationDate, 'dd.MM');
    const deadlineTimeStr = format(evaluationDate, 'HH:mm');

    return (
        <div className="assignment__evaluation-date-hint">
            <Text
                id="assignLessonModal.finalMode.resultsAvailableAt"
                values={{ date: deadlineDateStr, time: deadlineTimeStr }}
            />
        </div>
    );
};

export default AssignmentEvaluationDateHint;
